import { keyBy } from 'lodash'

import events from '@/services/events'

import normalizeFile from '../../util/normalizeFile'

const resetFiles = (state) => {
  state.files = []

  return state
}

export default {

  state: resetFiles({}),

  getters: {

    files ({ files }) {
      return files
    },

    filesBySlug (state, { files }) {
      return keyBy(files, 'fileSlug')
    },

    fileBySlug (state, { filesBySlug }) {
      return (fileSlug) => {
        return filesBySlug[fileSlug]
      }
    }

  },

  mutations: {

    resetFiles,

    createFile (state, fileData) {
      const file = normalizeFile(fileData)
      state.files.push(file)
      events.$emit('file:created', file)
    }

  },

  actions: {

    spawnFile ({ commit }, fileSlug) {
      commit('createFile', {
        fileSlug
      })
    }

  }

}
